module.exports = __webpack_public_path__ + "img/pm_banner_font.df5d477f.png";